import React, { useEffect, useState } from "react";
import "./OffersPage.css";
import { useSelector, useDispatch } from "react-redux";
import { setOffers } from "../../../../../store/app/appReducer";
import callApi from "../../../../../utility/apiCaller";
import { toast } from "react-toastify";
import { useNavigate } from "react-router-dom";
import { setUserClickData } from "../../../../../utility/setUserClickData";
import OfferCard from "./OfferCard";
import { TRACK_ID } from "../../../../../utility/enum";
import { useSearchParams } from "react-router-dom";
import _ from "lodash";

const OfferPage = ({ formData, setShowOfferHeaderLogo }) => {
  const lead = useSelector((state) => state.app.lead);
  const user = useSelector((state) => state.app.user);
  const offers = useSelector((state) => state.app.offers);
  const dispatch = useDispatch();
  const [isFinished, setIsFinished] = useState(false);
  const [leadId, setLeadId] = useState();
  const [expandedOfferId, setExpandedOfferId] = useState(null);
  const [activeLenders, setActiveLenders] = useState([]);
  const [params] = useSearchParams();
  const [isTncChecked, setIsTncChecked] = useState(true);
  const mobile = formData?.mobile || "";
  const navigate = useNavigate();
  const [source, setSource] = useState("");
  const token = user?.token;
  const [failedList, setFailedList] = useState([]);

  useEffect(() => {
    if (formData.stepDone === 3 && !leadId) {
      submitLead();
    }
  }, [formData]);

  useEffect(() => {
    if (offers.length > 0 && !expandedOfferId) {
      setExpandedOfferId(offers[0]._id);
    }
  }, [offers]);

  useEffect(() => {
    if (offers.length > 0) {
      setShowOfferHeaderLogo(false);
    }
  }, [offers]);

  const submitLead = async () => {
    setUserClickData({
      event_name: "submit-lead-ploan-offers",
      user_id: leadId || "No User ID found here",
      affiliate_id: params.get("aff_id") || "No Aff_id found",
    });

    try {
      const requestBody = {
        pageNum: 1,
        pageSize: 1000,
        filters: {
          lender_id: "66b76539fadd84ed521dcd2a",
          contact_phone: mobile,
        },
      };

      // 1️⃣ Fetch preapproved lead
      const leadResponse = await callApi(
        "v1/preapproved_lead/list",
        "post",
        requestBody,
        "core"
      );

      if (
        leadResponse.status === "Success" &&
        leadResponse?.data?.preapproved_leadList?.length > 0
      ) {
        const leadData = leadResponse.data.preapproved_leadList[0];

        // ✅ 2️⃣ Fetch Success + Fail lender details
        const lenderListRes = await callApi(
          `v1/lender_api_call/${leadData._id}/get-fail-success-lenders`,
          "post",
          {},
          "loan"
        );

        // ✅ Save Faillist
        if (Array.isArray(lenderListRes.data?.FailList)) {
          setFailedList(lenderListRes.data.FailList);
        }

        // ✅ 3️⃣ Build Successlist lookup map
        let lenderMap = {};
        if (Array.isArray(lenderListRes.data?.Successlist)) {
          lenderMap = Object.fromEntries(
            lenderListRes.data.Successlist.map((l) => [l.lender_id, l])
          );
        }

        // ✅ 4️⃣ Find matching lender details from Successlist
        const lenderDetails = lenderMap[leadData?.lender_id] || {};

        // ✅ 5️⃣ Select app_url based on aff_id
        const affId = params.get("aff_id") || "";
        let app_url = "";

        if (affId === "49") {
          app_url =
            "https://oneapp.abfldirect.com/epl/login?dsa_hash=fa5ca858df8252d459cb1f8d69be9210fca37b9efd43a6923e7b6dfe64171bf4";
        } else if (affId === "65") {
          app_url =
            "https://oneapp.abfldirect.com/epl/login?dsa_hash=f4e98261904411711255fc238b1e29e4b44e5ff5b4d0032d4b1189c581d0f138";
        }

        // ✅ 6️⃣ Build enriched offer object
        const offers = [
          {
            lead_id: leadData._id,
            lender_id: leadData?.lender_id,
            lender_name: lenderDetails.lender_name ?? leadData?.lender_name,
            credit_limit: lenderDetails.web_offer ?? leadData?.loan_amount,
            tenure: leadData?.loan_tenure,
            emi: leadData?.loan_emi,
            utm_medium: leadData?.utm_medium,
            aff_id: affId,
            logo_image_url: "https://digitmoney.in/assets/img/abc.png",
            app_url: app_url,

            // ✅ NEW Enriched Fields
            apr: lenderDetails.apr ?? "",
            kfs_doc: lenderDetails.kfs_doc ?? "",
            penal_charges: lenderDetails.penal_charges ?? "",
            processing_fee: lenderDetails.processing_fee ?? "",
            interest_rate: lenderDetails.web_interest ?? null,
          },
        ];

        // ✅ 7️⃣ Dispatch enriched offers
        dispatch(setOffers(offers));
        setIsFinished(true);
        return true;
      } else {
        navigate(`/personal-loan?source=${source}`);
      }
    } catch (error) {
      console.log("Error fetching lead or calling APIs:", error);
      setIsFinished(true);
      navigate(`/personal-loan?source=${source}`);
    }
  };

  return (
    <div id="offer-page-v5">
      {offers.length > 0 ? (
        <>
          <div className="final-offers-container-v5">
            <>
              {/* <video
                className="background-video1"
                src="/assets/img/BG video.mp4"
                autoPlay
                loop
                muted
              /> */}
              <img
                src="/assets/img/pre_Offer_page_BG_image1.png"
                alt="Square Check Background"
                className="background-overlay-img-offer"
              />
            </>
            <div className="offer-bg-layer-v5">
              <h2 className="congrats-text1-pre">Congratulations!</h2>
              <h3 className="sub-text1-pre">You’re Pre-Qualified for</h3>
              <h3 className="sub-text1-pre">a Personal Loan!</h3>
            </div>
          </div>

          <div className="offer-cards-container-new1">
            {offers.map((offer) => (
              <OfferCard
                key={offer._id}
                offer={offer}
                isExpanded={true}
                onExpand={() => setExpandedOfferId(offer._id)}
              />
            ))}
            <p className="disclaimer-offer-new-text-v5">
              Choose from these incredible offers that best suit your needs
            </p>
            <p className="disclaimer-text1">
              *These pre-approved offers are subject to change at discretion of
              Bank / NBFC after receiving all your documents and details. Final
              offer will be based on risk policy of Bank / NBFC. We do not
              guarantee that final offer will be same as Pre-approved offer.
            </p>
          </div>
        </>
      ) : isFinished ? (
        setShowOfferHeaderLogo(true) || (
          <div className="no-offers-found">
            <h2 className="congrats-text">
              There is no offer for you currently.
            </h2>
          </div>
        )
      ) : (
        setShowOfferHeaderLogo(true) || (
          <div className="no-offers-found">
            <h2 className="congrats-text">
              Please wait while we are searching best offers for you
            </h2>
          </div>
        )
      )}
    </div>
  );
};

export default OfferPage;
